import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { Control, useFieldArray, useForm } from "react-hook-form";
import { z } from "zod";

const zMoaUserForm = z.object({
	moaLastname: z.string(),
	moaFirstname: z.string(),
	streetNumber: z.string(),
	streetName: z.string(),
	postalCode: z.string(),
	city: z.string(),
});

export const zMoaForm = z.object({
	moaUsers: z.array(zMoaUserForm),
	siren: z.string(),
	denomination: z.string(),
	streetNumber: z.string(),
	streetName: z.string(),
	postalCode: z.string(),
	city: z.string(),
});

export type MoaFormData = z.infer<typeof zMoaForm>;

export interface MoaFormInitialValues {
	moaUsers?: {
		moaLastname?: string;
		moaFirstname?: string;
		streetNumber?: string;
		streetName?: string;
		postalCode?: string;
		city?: string;
	}[];
	siren?: string | null;
	denomination?: string | null;
	streetNumber?: string | null;
	streetName?: string | null;
	postalCode?: string | null;
	city?: string | null;
}

export const useMoaForm = (initialValues?: MoaFormInitialValues) => {
	const form = useForm<MoaFormData>({
		defaultValues: {
			moaUsers: [
				{
					moaLastname: "",
					moaFirstname: "",
					streetNumber: "",
					streetName: "",
					postalCode: "",
					city: "",
				},
			],
			siren: "",
			denomination: "",
			streetNumber: "",
			streetName: "",
			postalCode: "",
			city: "",
		},
		resolver: zodResolver(zMoaForm),
	});

	const { reset } = form;

	useEffect(() => {
		if (initialValues) {
			reset({
				moaUsers: initialValues.moaUsers ?? [
					{
						moaLastname: "",
						moaFirstname: "",
						streetNumber: "",
						streetName: "",
						postalCode: "",
						city: "",
					},
				],
				siren: initialValues.siren ?? "",
				denomination: initialValues.denomination ?? "",
				streetNumber: initialValues.streetNumber ?? "",
				streetName: initialValues.streetName ?? "",
				postalCode: initialValues.postalCode ?? "",
				city: initialValues.city ?? "",
			});
		}
	}, [reset, initialValues]);

	return { form };
};

export const useMoaUsersFieldArray = (control: Control<MoaFormData>) => {
	return useFieldArray({
		control,
		name: "moaUsers",
	});
};
